import {
  Box,
  Button,
  css,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useState } from 'react';
import { staticFileLocation } from '@server/constants';
import { darkBlue, lightGrey2 } from '@styles/colors';
import { bold, semibold } from '@styles/fontWeights';
import { useNavigate } from 'react-router-dom';
import theme from '@styles/theme';

import {
  FaceBookIcon,
  GoogleIcon,
  IndeedIcon,
  LinkidinIcon,
  TwitterIcon,
} from '../../vectors/index';
type RemoveAccessModalProps = {
  removeAccessOnModal: boolean;
  handleClose: () => void;
};

const RemoveAccessModal: FC<RemoveAccessModalProps> = ({
  removeAccessOnModal,
  handleClose,
}) => {
  const navigate = useNavigate();
  const handleNext = async (event: { preventDefault: () => void }) => {
    navigate('/dashboard');
    handleClose();
  };
  return (
    <Dialog
      open={removeAccessOnModal}
      maxWidth="xs"
      fullWidth
      disableEnforceFocus
      sx={{ background: 'transparent' }}
    >
      <DialogTitle>
        <img
          src={`${staticFileLocation}img/logos/LogoStampShadow.png`}
          css={css`
            max-width: 50px;
            width: 100%;
            margin-right: ${theme.spacing(2)};
            margin-top: 20px;
          `}
          alt="Logo"
        />
        <Typography
          variant="h1"
          sx={{
            p: 3,
            fontSize: '36px !important',
          }}
          fontWeight={semibold}
          lineHeight={1.4}
          dangerouslySetInnerHTML={{ __html: `Let’s  Post Your Job! 🎉` }}
        />

        <Typography
          variant="subtitle1"
          lineHeight={1.2}
          color={darkBlue}
          fontWeight={bold}
          sx={{ fontSize: '18px !important' }}
        >
          Follow a few easy steps and we'll have <br />
          you fully set up in just a few minutes.
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{ px: { sm: 4, md: 5 } }}
          alignItems="center"
          pb={4}
          spacing={2}
        >
          <Box textAlign="center" mt={5}>
            <Button
              onClick={handleNext}
              variant="contained"
              sx={{
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'transparent',
                padding: '5px 50px !important',
                '&:hover': {
                  borderColor: 'primary.main',
                  backgroundColor: 'transparent',
                  color: 'primary.main',
                  boxShadow: 'none',
                },
              }}
            >
              Let’s Go!
            </Button>
            <>
              <Typography lineHeight={1.2} fontSize={16} mt={5} color="gray">
                We'll help you customize your post for your specific needs, &
                get your job live on all major job boards so we can fill that
                role fast.
              </Typography>
              <Stack
                mt={3}
                mb={4}
                justifyContent="center"
                textAlign="center"
                direction="row"
                spacing={2}
              >
                <GoogleIcon />
                <IndeedIcon />
                <img
                  src={`${staticFileLocation}img/logos/glassdoor.png`}
                  css={css`
                    max-width: 30px;
                    height: 30px;
                    width: 100%;
                    object-fit: contain;
                  `}
                  alt="GlassDoor"
                />
                <FaceBookIcon />
                <LinkidinIcon />
                <TwitterIcon />
                <img
                  src={`${staticFileLocation}img/logos/job-inventory.png`}
                  css={css`
                    max-width: 40px;
                    height: 30px;
                    width: 100%;
                    object-fit: contain;
                  `}
                  alt="GlassDoor"
                />
              </Stack>
            </>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default RemoveAccessModal;
